var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.625V8.4375C13.125 6.8842 11.8658 5.625 10.3125 5.625H9.0625C8.54473 5.625 8.125 5.20527 8.125 4.6875V3.4375C8.125 1.8842 6.8658 0.625 5.3125 0.625H3.75M3.75 11.25H10M3.75 13.75H6.875M5.625 0.625H1.5625C1.04473 0.625 0.625 1.04473 0.625 1.5625V15.9375C0.625 16.4553 1.04473 16.875 1.5625 16.875H12.1875C12.7053 16.875 13.125 16.4553 13.125 15.9375V8.125C13.125 3.98286 9.76714 0.625 5.625 0.625Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon2);
export default __webpack_public_path__ + "static/media/file-icon-2.fc7edfb2115fa21bbc6c670ab7b6df11.svg";
export { ForwardRef as ReactComponent };